import { findFacetOnResponse, findItemInResponse } from '../../utils/index.js';
/**
 * @desc: Checks if labels are in the selected facets array.
 * return true If at least one label is missing.
 * @param selectedFacets
 * @param response
 */
export const shouldUpdateSelectedFacets = (selectedFacets, response) => {
    return selectedFacets.some((facetItem) => {
        if (!facetItem.facetLabel) {
            return true;
        }
        const responseFacet = findFacetOnResponse(response, facetItem.facetId);
        const responseFacetValue = responseFacet?.value?.find((item) => findItemInResponse(item, facetItem));
        return !!(responseFacetValue && responseFacetValue.text && !facetItem.valueLabel);
    });
};
const reduceFromApi = (selectedFacet, response) => {
    const newValue = response.value.find((item) => findItemInResponse(item, selectedFacet));
    const newSelectedFacet = selectedFacet;
    return {
        ...newSelectedFacet,
        facetValueId: newValue ? newValue.id : newSelectedFacet.facetValueId,
        facetLabel: response.label || selectedFacet.facetLabel,
        valueLabel: newValue ? newValue.text : selectedFacet.valueLabel,
    };
};
const widgetDataRequestSuccessReducer = (state) => {
    const { selectedFacets = [], response } = state;
    if (shouldUpdateSelectedFacets(selectedFacets, response)) {
        return {
            ...state,
            selectedFacets: selectedFacets.map((currentSelectedFacet) => {
                const responseFacet = findFacetOnResponse(response, currentSelectedFacet.facetId);
                if (responseFacet) {
                    return reduceFromApi(currentSelectedFacet, responseFacet);
                }
                return currentSelectedFacet;
            }),
        };
    }
    return state;
};
export default widgetDataRequestSuccessReducer;
